import React, {useState} from 'react';
// import { Image } from 'react-bootstrap';
import CustomButton from '../customButton';
import { Link } from 'react-router-dom';
import CSS from './layout.module.css';

const ProductDetails = ({ product, onButtonAddToCart }) => {

    const {name, description, price, supplier, multipleVoltages, voltageOptions} = product.data.attributes;

    const isLoggedIn = localStorage.getItem('vp-portal-token') !== null;

    const sentences = description ? description.split('.') : [];

    const formattedPrice = price ? new Intl.NumberFormat('nb-NO', { style: 'currency', currency: 'NOK' }).format(price) : '';

    const [selectedVoltage, setSelectedVoltage] = useState(voltageOptions && voltageOptions.length > 0 ? voltageOptions[0].voltage : '');
    
    const handleVoltageChange = (event) => {
        setSelectedVoltage(event.target.value);
    }

return (
    <div>
        <div>
            <h1>{name.toUpperCase()}</h1>
        </div>
        <div className="my-4 underline">
            Produsent: {supplier.data.attributes.name}
        </div>
        {isLoggedIn ? (
                <>
                    <div className={CSS.container}>
                        {/* <div className="mt-4 overstreket">Original pris: {formattedPrice}</div>
                        <div className="overstreket">Estimert frakt: {estimertFraktOnScreen}</div>
                        <div className="">Du har frakt inkludert!</div>
                        {/* <div className="understreket">Total rabatt: {estimertRabattOnScreen}</div> */}
                        <div className={`${CSS.bold} my-4`}>Pris: {formattedPrice}</div>
                        {/* <div className="total-pris mt-3">Din pris ink frakt: {totalPrisOnScreen}</div> */}
                        {/* <div className={CSS.selectContainer}>
                            <label htmlFor="voltageDropdown">Velg spenning:</label>
                            <select className={CSS.select} id="voltageDropdown" value={voltage || "230V"} onChange={handleVoltageChange}>
                                <option value="230V">230 V</option>
                                <option value="400V">400 V</option>
                            </select>
                        </div> */}
                        {multipleVoltages && (
                            <div className={CSS.selectContainer}>
                                <label htmlFor="voltageDropdown">Velg spenning:</label>
                                <select
                                    className={CSS.select}
                                    id="voltageDropdown"
                                    value={selectedVoltage}
                                    onChange={handleVoltageChange}
                                >
                                    {voltageOptions.map((option, index) => (
                                        <option key={index} value={option.voltage}>
                                            {option.voltage}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        <div className="my-4">
                            <CustomButton
                                label="Legg i handlevogn"
                                className="add-to-cart-button text-white"
                                onClick={() => onButtonAddToCart(selectedVoltage)}
                            />
                        </div>
                    </div>
                    
                </>
            ) : (
                <div className="mt-4">
                    <Link to="/login" className={CSS.link}> Logg inn</Link><p> for å se priser,
                        <br></br>
                        <br></br>
                        eller legg til i handlekurven for å be om prisestimat. </p>
                        {multipleVoltages && (
                            <div className={CSS.selectContainer}>
                                <label htmlFor="voltageDropdown">Velg spenning:</label>
                                <select
                                    className={CSS.select}
                                    id="voltageDropdown"
                                    value={selectedVoltage}
                                    onChange={handleVoltageChange}
                                >
                                    {voltageOptions.map((option, index) => (
                                        <option key={index} value={option.voltage}>
                                            {option.voltage}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        <div className="my-4">
                            <CustomButton
                                label="Legg i handlevogn"
                                className="add-to-cart-button text-white"
                                onClick={() => onButtonAddToCart(selectedVoltage)}
                            />
                        </div>
                </div>
            )}
        <div className={CSS.description}>
            {sentences.map((sentence, index) => (
            // Bruk index som nøkkel (hvis det ikke er en unik id tilgjengelig)
            // Legg også til en nøkkel til <p>-taggen for å unngå advarsler om manglende nøkkel
            <p key={`sentence-${index}`}>
                {sentence.trim()} {/* Fjern ekstra mellomrom */}
            </p>
            ))}
        </div>
    </div>
  );
};

export default ProductDetails;
